import { ChartLineUp, Star } from "@phosphor-icons/react";
import { SectionShell } from "../../styleguide/Primitives";
import { Showcase } from "../LibraryPrimitives";
import { ProgressRing, MasteryCard, MasteryBadge, StreakCard, CompletionIndicator } from "../progress";
import { BloomProgress } from "../../styleguide/ui/BloomProgress";

export function ProgressSection() {
  return (
    <SectionShell
      id="progress"
      eyebrow="Progress"
      eyebrowIcon={ChartLineUp}
      title="Growth you can see, not just count"
      description="Progress is shown as growth — a seed becoming a bloom — so children feel achievement, not arithmetic. Numbers support the story; they never carry it alone."
    >
      <div className="space-y-8">
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          <Showcase title="Progress ring">
            <div className="flex items-center justify-center">
              <ProgressRing value={72} color="primary">
                <span className="font-display text-2xl font-black">72%</span>
                <span className="text-xs font-bold text-muted-foreground">Today</span>
              </ProgressRing>
            </div>
          </Showcase>
          <Showcase title="Ring · with icon">
            <div className="flex items-center justify-center">
              <ProgressRing value={100} color="teal">
                <Star size={30} weight="fill" className="text-secondary" />
              </ProgressRing>
            </div>
          </Showcase>
          <Showcase title="Completion">
            <div className="flex flex-col gap-3">
              <CompletionIndicator state="not-started" />
              <CompletionIndicator state="in-progress" />
              <CompletionIndicator state="complete" />
            </div>
          </Showcase>
          <Showcase title="Progress bars">
            <div className="space-y-4">
              <BloomProgress value={40} color="primary" />
              <BloomProgress value={70} color="teal" />
              <BloomProgress value={90} color="blue" />
            </div>
          </Showcase>
        </div>

        <Showcase title="Mastery levels" description="Seed → Growing → Strong → Mastered (never a bare percentage)" tone="muted">
          <div className="mb-5 flex flex-wrap gap-2">
            <MasteryBadge level="seed" />
            <MasteryBadge level="growing" />
            <MasteryBadge level="strong" />
            <MasteryBadge level="mastered" />
          </div>
          <div className="grid gap-4 sm:grid-cols-2">
            <MasteryCard subjectLabel="Addition" level="growing" />
            <MasteryCard subjectLabel="Multiplication" level="strong" />
            <MasteryCard subjectLabel="Phonics" level="mastered" />
            <MasteryCard subjectLabel="Fractions" level="seed" />
          </div>
        </Showcase>

        <Showcase title="Streak card">
          <div className="max-w-sm"><StreakCard days={5} /></div>
        </Showcase>
      </div>
    </SectionShell>
  );
}

export default ProgressSection;
